import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import { Panel } from "primereact/panel";
import { Employee } from "../../service/Employee";
import { Message } from "primereact/message";
import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

let filterObj = {};
function EmployeeList() {
    const [empData, setEmpData] = useState([]);
    const [empDataDuplicate, setEmpDataDuplicate] = useState([]);
    const [search, setSearch] = useState("");
    const [city, setCity] = useState(null);
    const [circle, setCircle] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCircle, setSelectedCircle] = useState(null);
    const serviceID = localStorage.getItem("serviceId");
    const employee = new Employee();
    const [showFilter, setShowFilter] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState(null);
    const [calendarKey, setCalendarKey] = useState(0); // Used to force re-render
    const [dateColumns, setDateColumns] = useState([]);

    const toast = useRef(null);

    useEffect(() => {
        setSelectedMonth(new Date());
    }, []);

    useEffect(() => {
        if (selectedMonth) {
            const start = moment(selectedMonth).startOf("month");
            const end = moment(selectedMonth).endOf("month");
            const columns = [];

            for (let d = moment(start); d.isSameOrBefore(end); d.add(1, "day")) {
                columns.push(d.format("DD MMM")); // Example: "01 May", "02 May"
            }

            setDateColumns(columns);
        }
    }, [selectedMonth]);
    const handleFilter = (ftype, value) => {
        if (ftype !== "search") filterObj[ftype] = value.code;
        else filterObj[ftype] = value;

        if (ftype === "search") setSearch(value);
        if (ftype === "city") setSelectedCity(value);
        if (ftype === "circle") setSelectedCircle(value);

        let filterArr = [],
            search;
        Object.keys(filterObj).forEach((f) => {
            if (f === "search") search = filterObj[f];
            else filterArr.push([f, filterObj[f]]);
        });
        let resp = filterItems(empDataDuplicate, filterArr, search);
        setEmpData(resp);
    };

    const filterItems = (data, filters, search) => {
        return data.filter(function (emp) {
            for (var i = 0; i < filters.length; i++) {
                if (emp[filters[i][0]] !== filters[i][1]) return false;
            }
            if (search) {
                let srch = search.toLowerCase();
                if (emp.name.toLowerCase().includes(srch) || emp.employeeID.includes(srch)) return true;
                else return false;
            }
            return true;
        });
    };

    const template = (options) => {
        const className = `${options.className} justify-content-between`;
        const titleClassName = `${options.titleClassName} pl-1`;
        const toggleIcon = options.collapsed ? "pi pi-chevron-down" : "pi pi-chevron-up";

        return (
            <div className={className} style={{ backgroundColor: "#FAFAFA" }}>
                <span className={titleClassName}>
                    <i className="pi-pw pi pi-filter"></i> Filter
                </span>
                <Message style={{ background: "none" }} text="Search filter applied on User Name and Employee Id" />
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
            </div>
        );
    };
    const onMonthChange = (e) => {
        const selected = e.value;
        const now = moment(); // current month
        const selectedMoment = moment(selected);

        if (selectedMoment.isAfter(now, "month")) {
            // If selected month is after current month, prevent setting it
            toast?.current?.show({ severity: "error", summary: "Error", detail: "Future months cannot be selected", life: 3000 });
            setCalendarKey((prev) => prev + 1); // Force reset calendar by changing key
            return;
        }
        setSelectedMonth(selected);
    };
    const onDownload = () => {
        const safeData = empData || [];

        // Define column mapping: key = data field, value = Excel header label
        const columnHeaderMap = {
            employeeID: "Employee Id",
            name: "User Name",
            circle: "Circle",
            city: "City",
        };

        const staticColumns = Object.keys(columnHeaderMap);

        // Dynamically extract date columns (if any)
        const dynamicDateColumns = safeData.length ? dateColumns : [];

        const allColumns = [...staticColumns, ...dynamicDateColumns];

        // Format data rows
        const formattedData = safeData.length
            ? safeData.map((row) => {
                  const formattedRow = {};
                  allColumns.forEach((col) => {
                      // Use columnHeaderMap for known columns, otherwise keep date as-is
                      const header = columnHeaderMap[col] || col;
                      formattedRow[header] = row[col] ?? "";
                  });
                  return formattedRow;
              })
            : [
                  Object.fromEntries(
                      allColumns.map((col) => {
                          const header = columnHeaderMap[col] || col;
                          return [header, ""];
                      })
                  ),
              ];

        // Generate Excel
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `Monthly Report.xlsx`);
    };

    const getDurationString = (start, end) => {
        if (!start || !end) return "--";

        const startMoment = moment(start);
        const endMoment = moment(end);
        const duration = moment.duration(endMoment.diff(startMoment));

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        return `${hours.toString().padStart(2, "0")} hr ${minutes.toString().padStart(2, "0")} min`;
    };

    const initReport = (fromDate, toDate) => {
        let thingEmpIdMap = {},
            employeeDetails = [];

        employee
            .getAllEmployee(serviceID)
            .then((res) => {
                if (res.responseData?.length) {
                    // console.log(`employeeData - ${JSON.stringify(res.responseData)}`);

                    res.responseData.forEach((item) => {
                        if (item) {
                            thingEmpIdMap[item.thingName] = item;
                            employeeDetails.push(item);
                        }
                    });
                    const monthStart = moment(selectedMonth).startOf('month').format("YYYY-MM-DD");
                    const monthEnd = moment(selectedMonth).endOf('month').format("YYYY-MM-DD");
                    const locationPayload = {
                        filter: {
                            thingName: { $in: Object.keys(thingEmpIdMap) },
                            date: { $gte: monthStart, $lte: monthEnd },
                        },
                        projection: { thingName: 1, startTime: 1, endTime: 1, _id: 0 },
                    };

                    employee.getLocationData(serviceID, locationPayload).then((employeeLocationData) => {
                        const dayMap = {};
                        employeeLocationData.forEach((entry) => {
                            const emp = thingEmpIdMap[entry.thingName];
                            const empId = emp.empId;
                            const dateKey = moment(entry.startTime).format("DD MMM");

                            if (!dayMap[empId]) dayMap[empId] = {};
                            dayMap[empId][dateKey] = getDurationString(entry.startTime, entry.endTime);
                        });

                        const daysInMonth = Array.from({ length: moment(toDate).date() }, (_, i) =>
                            moment(fromDate)
                                .date(i + 1)
                                .format("DD MMM")
                        );
                        const finalRows = employeeDetails.map((emp) => {
                            const empId = emp.empId;
                            const row = {
                                employeeID: empId,
                                name: emp.name,
                                circle: emp.circle || "",
                                city: emp.city || "",
                            };

                            daysInMonth.forEach((day) => {
                                row[day] = dayMap[empId]?.[day] || "";
                            });

                            return row;
                        }).filter(row => daysInMonth.some(day => row[day]));

                        if (finalRows.length === 0) {
                            setEmpData([]);
                            setEmpDataDuplicate([]);
                            setCity([]);
                            setCircle([]);
                            return;
                        }
                        let city = [];
                        let circle = [];

                        finalRows.forEach((elm) => {
                            if (elm.city && !city.some((a) => a.name === elm.city)) {
                                city.push({ name: elm.city, code: elm.city });
                            }
                            if (elm.circle && !circle.some((a) => a.name === elm.circle)) {
                                circle.push({ name: elm.circle, code: elm.circle });
                            }
                        });

                        setCity(city);
                        setCircle(circle);
                        setEmpData(finalRows);
                        setEmpDataDuplicate(finalRows);
                    });
                }
            })
            .catch(console.error);
    };

    useEffect(() => {
        if (selectedMonth) {
            const startOfMonth = moment(selectedMonth, "YYYY-MM").startOf("month").format("YYYY-MM-DD 00:00:00");
            const endOfMonth = moment(selectedMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD 23:59:59");
            initReport(startOfMonth, endOfMonth);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMonth]);
    const onReset = () => {
        filterObj = {};
        setSelectedMonth(new Date());
        setSearch("");
        setSelectedCity(null);
        setSelectedCircle(null);
    };

    return (
        <>
            <Toast ref={toast} />
            <h4 className="text-lg">Tracking</h4>
            <div className="card border-radius-12px">
                <p className="text-lg font-bold">Detailed Report</p>
                <div className="grid justify-content-between">
                    <div className="col-12 md:col-7">
                        <div className="grid align-items-center">
                            <div className="col-12 lg:col-7 lg:mr-2 flex lg:flex-nowrap flex-wrap align-items-center" style={{ gap: 10 }}>
                                <span className="font-bold text-base white-space-nowrap">Select Date </span>
                                <Calendar id="month" value={selectedMonth} key={calendarKey} onChange={onMonthChange} view="month" dateFormat="MM/yy" showIcon placeholder="Select Month" readOnlyInput style={{ backgroundColor: "#FAFAFA" }} className="input-border w-full" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="col-12">
                            <div className="grid " style={{ gap: 8, flexWrap: "wrap" }}>
                                <div className="">
                                    <Button style={{ color: "#2A9D8F" }} icon="pi pi-file" label="Download Report" className=" p-button-outlined border-radius-12px" aria-label="Submit" onClick={onDownload} />
                                </div>
                                <div className="">
                                    <Button label="Reset" className="p-button-outlined p-button-danger border-radius-12px" onClick={onReset} />
                                </div>
                                <div className="">
                                    <Button label="Filter" icon="pi pi-filter" iconPos="right" className="p-button-outlined border-radius-12px" onClick={() => setShowFilter(!showFilter)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showFilter && (
                    <Panel headerTemplate={template} toggleable collapsed={false}>
                        <div className="grid">
                            <div className="col-12 md:col-2 pt-3">
                                <InputText value={search} onChange={(e) => handleFilter("search", e.target.value)} className="w-full input-border" placeholder="Search" />
                            </div>
                            <div className="col-12 md:col-2">
                                <Dropdown value={selectedCity} options={city} onChange={(e) => handleFilter("city", e.target.value)} optionLabel="name" placeholder="City" className="m-2 input-border w-full" />
                            </div>
                            <div className="col-12 md:col-2">
                                <Dropdown value={selectedCircle} options={circle} onChange={(e) => handleFilter("circle", e.target.value)} optionLabel="name" placeholder="Circle" className="m-2 input-border w-full" />
                            </div>
                        </div>
                    </Panel>
                )}

                <div className="datatable-selection-demo mt-4">
                    <div className="card">
                        <DataTable value={empData} dataKey="startTime" showGridlines responsiveLayout="scroll" rows={10} paginator>
                            <Column header="Employee Id" headerClassName="blue-bg white-space-nowrap" field="employeeID"></Column>
                            <Column header="User Name" headerClassName="blue-bg white-space-nowrap" field="name" bodyClassName="white-space-nowrap"></Column>
                            <Column header="Circle" headerClassName="blue-bg white-space-nowrap" field="circle"></Column>
                            <Column header="City" headerClassName="blue-bg white-space-nowrap" field="city"></Column>
                            {dateColumns.map((date) => (
                                <Column key={date} header={date} field={date} headerClassName="blue-bg white-space-nowrap" bodyClassName="white-space-nowrap" />
                            ))}
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmployeeList;
